class ThemeSwitch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleThemeToggle = this.handleThemeToggle.bind(this)

    this.listeners.add(
      this.els.toggle.element,
      'click',
      this.handleThemeToggle,
    )
  }

  async handleThemeToggle () {
    const newTheme = this.dataset.theme === 'light' ? 'dark' : 'light'

    this.externalEls.loading.element.setAttribute('aria-busy', true)

    await window.BAO.Cart.updateCartAttributes({
      theme_colour: newTheme,
    })

    window.setTimeout(() => {
      this.setAttribute('data-theme', newTheme)

      this.els.text.element.innerText =
        newTheme === 'light' ? this.dataset.light : this.dataset.dark

      document.body.classList.toggle('lyt-Theme-dark', newTheme === 'dark')
      document.body.classList.toggle('lyt-Theme-light', newTheme === 'light')

      this.externalEls.loading.element.setAttribute('aria-busy', 'false')
    }, 100)
  }
}

if (!customElements.get('theme-switch')) {
  customElements.define('theme-switch', ThemeSwitch)
}
